import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";

type OrderTrackingRequestedProps = {
  orderNumber: string;
  email: string;
};

type OrderTrackingRequestedAnalyticsProps = {
  order_number: string;
  email: string;
};

export type OrderTrackingRequestedEvent = TrackingEvent<
  "Order Tracking Requested",
  OrderTrackingRequestedAnalyticsProps
>;

export async function trackOrderTrackingRequestedEvent({
  orderNumber,
  email,
}: OrderTrackingRequestedProps): TrackingEventResponse {
  return await trackEvent("Order Tracking Requested", {
    props: {
      order_number: orderNumber,
      email,
    },
    withRequestSource: true,
  });
}
